import { Stack, Typography, Link as MuiLink, Divider, Box, BottomNavigation, BottomNavigationAction } from '@mui/material';
import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { IconChartAreaLine } from '@tabler/icons';
import { IconClipboardData } from '@tabler/icons';
import { IconDatabaseImport } from '@tabler/icons';
// project imports

// ==============================|| MINIMAL LAYOUT ||============================== //

function LeadGenDataLayout() {
    return (
        <React.Fragment>
            <Outlet />
        </React.Fragment>
    );
}

export default LeadGenDataLayout;
